import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

const FinalSubmissionDialog = ({
  open,
  onClose,
  onSubmit,
  isTimeUp,
  stats,
  submitError,
  countdownTime,
  finalSubmitChecked,
  onFinalSubmitCheck,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{isTimeUp ? "Time's Up!" : "Final Submission"}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant="body1">Total Questions: {stats.totalQuestions}</Typography>
          <Typography variant="body1">Total Answered: {stats.attemptedWithAnswered}</Typography>
          <Typography variant="body1">Marked with answered: {stats.markedWithAnswered}</Typography>
          <Typography variant="body1">Marked without answered: {stats.markedWithotAnswered}</Typography>
          <Typography variant="body1">Not Answered: {stats.attemptedWithoutAnswered}</Typography>
          <Typography variant="body1">Not Viewed: {stats.notViewedQ}</Typography>
          {submitError && (
            <Typography color="red" variant="body1">
              {submitError}
            </Typography>
          )}
          {isTimeUp && countdownTime && (
            <Typography variant="body2" style={{ marginTop: "1rem" }}>
              You will be navigated in {countdownTime} seconds to the end page. Your exam has been submitted.
            </Typography>
          )}
        </DialogContentText>
        {!isTimeUp && (
          <FormControlLabel
            control={<Checkbox checked={finalSubmitChecked} onChange={onFinalSubmitCheck} color="primary" />}
            label="I confirm that I want to finally submit the exam."
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={isTimeUp}>
          Cancel
        </Button>
        <Button onClick={onSubmit} color="primary" disabled={!isTimeUp && !finalSubmitChecked}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FinalSubmissionDialog;